// extracted by css-extract-rspack-plugin
export default {"form":"JQs8P5h3S78HPep0","fields":"uVRgdnFjbHoWx8M0","fieldPeriod":"kdmHua5TtWQYt2pp","buttons":"p3oZBPurGtMd0cSP"};